import { DecodedIslandSku } from '../types';
import { IslandType } from '../../blueprint-classes';
import { emptyIslandDefaults, EmptyIslandDefaults } from '../../helpers';

export const decodeIslandSku = (sku: string): DecodedIslandSku | null => {
	if (sku === null) return null;

	// eslint-disable-next-line prefer-named-capture-group
	const reg = /(.)([0-9]+)([a-z]*)/u;
	const foo = sku.split('-')[1]?.toLowerCase();
	const m = foo?.match(reg);

	const parts = m?.splice(1) ?? [];
	if (parts.length < 3) return null;
	if (parts[0] === 'k') parts[2] = 'k';
	// console.log('schema:decode-island-sku', sku, parts);

	const islandSubType: EmptyIslandDefaults = ((st) => {
		switch (st) {
			case 'c':
				return EmptyIslandDefaults.corner;
			case 'b':
				return EmptyIslandDefaults.bar;
			case 'k':
				return EmptyIslandDefaults.asado;
			case 'p':
				return EmptyIslandDefaults.pizza;
			default:
				return EmptyIslandDefaults.grill;
		}
	})(parts[2]);

	const islandDetails = emptyIslandDefaults[islandSubType]

	// use the width code when island is a grill or bar
	if (['grill', 'bar'].indexOf(islandSubType) !== -1) {
		islandDetails.width = Number(parts[1]) * 12;
	}

	const islandType: IslandType = ((st) => {
		switch (st) {
			case 'c':
				return IslandType.Corner;
			case 'b':
				return IslandType.Bar;
			case 'k':
				return IslandType.Asado;
			case 'p':
				return IslandType.Pizza;
			case 's':
				return IslandType.Smoker;
			default:
				return IslandType.Grill;
		}
	})(parts[2]);

	const decodedSku = {
		islandType,
		islandWidthCode: parts[1],
		islandSubType,
		islandDetails
	};

	// console.log('schema:decode-island-sku', sku, decodedSku);
	return decodedSku;
}
